import { ChevronRightIcon } from '@heroicons/react/24/outline'
import dayjs from 'dayjs'
import { useRouter } from 'next/navigation'
import { useMemo } from 'react'

import { NewIcon } from '@/shared/layout/WithCurriculumLayout/Icons'
import { checkRegister24HoursAgo } from '@/shared/utils/checkRegister24HoursAgo'

interface ICurriculumKlassTasksProps {
  id: string

  curriculumId: string
  data: {
    startedAt: string | undefined
    endedAt: string | undefined
    isSubmitted: boolean
  }
}

type ICardData = {
  [key: string]: { title: string; imgSrc: string }
}

const CurriculumKlassTasks = ({ id, curriculumId, data }: ICurriculumKlassTasksProps) => {
  const router = useRouter()

  const cardData: ICardData = {
    project: {
      title: '프로젝트',
      imgSrc: 'https://d35ai18pny966l.cloudfront.net/b2b/b2b_icon_project.png',
    },
    survey: {
      title: '설문조사',
      imgSrc: 'https://d35ai18pny966l.cloudfront.net/b2b/b2b_icon_survey.png',
    },
  }

  const { title, imgSrc } = cardData[id]

  const isNew = useMemo(() => {
    if (data.startedAt) {
      return checkRegister24HoursAgo(dayjs(data.startedAt).format('YYYY-MM-DD HH:mm'))
    }
    return false
  }, [data])

  return (
    <button
      className={`relative flex w-full flex-row items-center gap-3 rounded-2xl border px-3 py-4 md:w-[calc(50%-12px)] md:gap-4 md:px-5 ${
        data.isSubmitted ? 'bg-white' : 'cursor-pointer border-transparent bg-primary-subdued'
      }`}
      onClick={() => router.push(`/${curriculumId}/${id}`)}
    >
      <div
        className={`flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-white lg:h-16 lg:w-16 ${data.isSubmitted ? 'shadow-[2px_8px_20px_-5.389px_rgba(22,52,80,0.10)]' : 'shadow-[2px_6px_15px_-4.042px_rgba(22,52,80,0.10)]'}`}
      >
        <img
          className="h-10 w-10 bg-white object-contain lg:h-[54px] lg:w-[54px]"
          src={imgSrc}
          alt={title}
        />
      </div>

      <div className="flex flex-1 flex-col items-start md:gap-1">
        <div className="flex flex-row items-center gap-1">
          <h6
            className={`text-base font-semibold md:text-lg ${
              data.isSubmitted ? 'text-label-normal' : 'text-primary-light'
            }`}
          >
            {title}
          </h6>
          {isNew && !data.isSubmitted && <NewIcon />}
          <ChevronRightIcon className="w-4 shrink-0 stroke-[1.34px] text-label-neutral md:w-5" />
        </div>
        <p className="text-sm text-label-neutral">
          {data.isSubmitted ? (
            <>예정된 {title}가 없어요.</>
          ) : (
            <>
              <span className="font-semibold text-primary-normal">예정된 {title}</span>가 있어요.
            </>
          )}
        </p>
      </div>
    </button>
  )
}

export default CurriculumKlassTasks
